import React, { useState, useEffect } from 'react'
import {
    InputBase,
    Grid,
    Button
} from "@material-ui/core";
import useStyles from "./styles";
import { SearchOutlined as SearchIcon } from '@material-ui/icons';
import ClearIcon from '@material-ui/icons/Clear';
import SearchGrid from '../../../components/table/SearchGrid';
import Breadcrums from '../../../components/BreadCrums/breadcrums';
import TopSpacer from '../../../components/Common/spacer/TopSpacer';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { PostDataAPI } from '../../../Services/APIService';
import Loader from '../../../components/Loader/Loader';
import { ActionDialog } from "../../../components/ActionDialog/ActionDialog";
import { withSnackbar } from "../../../components/Message/Alert";
import AddNewUser from './components/addNewRight';


function Rights({ ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    const [editItem, setEditItem] = useState({});
    const [addNewUserDialog, setAddNewUserDialog] = useState(false);

    //action dialog
    const [actiondialogState, setActionDialogState] = useState({
        showHide: false, type: "confirm", message: "",
    })

    const showActionDialog = (message, type, OnOkCallback, OnCancellCallback) => {
        setActionDialogState(prevState => ({
            ...prevState,
            type: type,
            showHide: true,
            message: message,
            onClickOk: OnOkCallback,
            OnClickCancel: OnCancellCallback
        }));
    }



    const handleActionClick = (key, item) => {

        if (key === "editRight") {
            editUser(item);
            // setEditItem(item);
        }
        else if (key === 'deleteRight') {
            deleteUser(item)
            // setEditItem(item);
        }
    }

    const deleteUser = (item) => {
        showActionDialog("Warning: Are you sure you want to delete this right?", "confirm", function () {
            var params = { rightId: item.rightId }
         
            setIsLoading(true);
            PostDataAPI("fdnrights/delete", params, false).then((result) => {
                debugger
                if (result.success) {
                    showMessage("Success", "Right deleted successfully", "success", 3000);
                    loadUsersGrid();
                } else {
                    showMessage("Error", result.message, "error", 3000);
                }
                setIsLoading(false);
            })
        });
    }
    const editUser = (item) => {
        setEditItem(item);
        setAddNewUserDialog(true);
    }
    const closeAddUser = () => {
        setEditItem({});
        setAddNewUserDialog(false);
    }
    const handleSuccessClose = (message) => {
        setEditItem({});
        closeAddUser();
        showMessage("Success", message, "success", 3000);
        loadUsersGrid();
    }
    const addUser = () => {
        setEditItem({});
        setAddNewUserDialog(true);
    }
    const [isDataGridUpdate, setIsDataGridUpdate] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [usersData, setUsersData] = useState([]);


    const handleDataGridUpdate = () => {
        setIsDataGridUpdate(!isDataGridUpdate);
    }

    const [searchFilter, setValue] = useState('');
    const handleSearch = (e) => {
        const currValue = e.target.value;
        if (currValue.trim().length > 0 || currValue == '') {
            setValue(currValue);
            handleDataGridUpdate()
        }
    }
    // Function to clear the input field
    const handleClearInput = (name) => {
        setValue('');
        handleDataGridUpdate();
    };

    const loadUsersGrid = () => {
        setIsLoading(true);
        PostDataAPI("fdnrights/loadGrid").then((result) => {
            if (result.success && result.data != null) {
                setUsersData(
                    result.data.map((item, i) => {
                        //item.completeAddress = (
                        //    (item.address1 ?? '') +
                        //    (item.address2 ? ' ' + item.address2 : '') +
                        //    (item.city ? ' ' + item.city : '') +
                        //    (item.state ? ', ' + item.state : '') +
                        //    (item.zipCode ? ' ' + item.zipCode : '')
                        //).trim();
                        item.fullName = item.firstName ? item.firstName + ' ' + item.lastName : '';
                        return { ...item };
                    }));

            }
            else {
                setUsersData([]);
            }
            handleDataGridUpdate();
            setIsLoading(false);

        })
    }

    useEffect(() => {
        loadUsersGrid();
    }, []);

    return (
        <>
            {isLoading ? <Loader></Loader> : ''}
            <TopSpacer></TopSpacer>

            <div className={classes.header}>

                <Grid container alignItems="baseline">
                    <Grid item lg={12}>
                        <Breadcrums parentLink={"Setup"} currentLink={"User Rights"} isBack={true}></Breadcrums>
                    </Grid>
                </Grid>
            </div>

            <Grid container className={classes.container}>
                <h1 className={classes.heading}>
                  User Rights
                </h1>
            </Grid>



            <Grid row className={classes.gridHeader}>
                <div className={classes.gridActions}>
                    <Button className={classes.changeBtn} onClick={() => addUser()}><AddCircleOutlineIcon style={{ marginRight: '6px' }} /> Add New</Button>
                </div>
                <div className={classes.gridActions} style={{ marginRight: '7px' }} >
                    <InputBase
                        value={searchFilter}
                        placeholder="Search"
                        className="grid-search-input"
                        endAdornment={searchFilter ? <ClearIcon style={{ cursor: 'pointer' }} onClick={() => { handleClearInput('search') }} /> : ''}
                        startAdornment={<SearchIcon />}
                        onChange={handleSearch}
                        autoComplete={'off'}
                    />
                </div>

            </Grid>



            <Grid row className={classes.container} >
                <SearchGrid columns="customerRights"
                    list={usersData}
                    noRecordMsg="No record exists"
                    Icon={true}
                    isUpdate={isDataGridUpdate}
                    filter={searchFilter}
                    onDeleteClick={deleteUser}
                    onEditClick={editUser}
                    isTopPagination={true}
                    onActionClick={handleActionClick}
                />
            </Grid>

            {addNewUserDialog ?
                <AddNewUser
                    dialogOpenClose={addUser}
                    handleClose={closeAddUser}
                    handleSuccessClose={handleSuccessClose}
                    data={editItem}
                ></AddNewUser>
                : ''}

            <ActionDialog
                type={actiondialogState.type}
                message={actiondialogState.message}
                actiondialogOpenClose={actiondialogState.showHide}
                onSubmit={actiondialogState.onClickOk}
                onCancel={() =>
                    setActionDialogState(prevState => ({
                        ...prevState, showHide: false
                    }))
                }
                onClose={() => setActionDialogState(prevState => ({
                    ...prevState, showHide: false
                }))

                }
            />

        </>
    )

}

export default withSnackbar(Rights);